import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import ReactMarkdown from 'react-markdown'
import s from './CoronaTerms.css'

class FAQDropdown extends Component {
  state = {
    isShow: false,
  }

  componentDidMount() {
    const { id } = this.props
    const el = document.getElementById(`dropdown_content__${id}`)
    el.style.height = 0
  }

  handleToggleClick = () => {
    const { id } = this.props
    this.setState(
      prevState => ({
        isShow: !prevState.isShow,
      }), () => {
        const el = document.getElementById(`dropdown_content__${id}`)
        if (this.state.isShow) {
          el.style.height = `${el.scrollHeight}px`
        } else {
          el.style.height = 0
        }
      }
    )
  }


  render() {
    const { isShow } = this.state
    const { id, question, answer } = this.props

    return (
      <div className={s.dropdown_container}>
        <div className={s.dropdown_header} onClick={() => this.handleToggleClick()}>
          <p>{question}</p>
          <i className={isShow ? s.show_dropdown : ''} />
        </div>
        <div id={`dropdown_content__${id}`} className={`${s.dropdown_content} ${isShow ? s.show_dropdown : ''}`}>
          {/* <p>{answer}</p> */}
          <ReactMarkdown source={answer} escapeHtml={false} />
        </div>
      </div>
    )
  }
}

export default withStyles(s)(FAQDropdown)
